import {
  HOME_PATH,
  ERROR_PATH,
  ABOUT_PATH,
  CONTACT_PATH,
  SERVICES_PATH,
  WEBDESIGN_PATH,
  CLOUDHOSTING_PATH,
  WEBAPPDEV_PATH,
  CORPORATE_PATH,
  SEO_PATH,
  CONSULTANCY_PATH,
  CAR_RENTAL_PATH,
  FLEET_MANAGMENT_PATH,
} from "./paths";

// import Error from "pages/Error";
import Home from "../pages/Home";
import AboutUs from "../pages/AboutUs";
import ContactUs from "../pages/ContactUs";
import Services from "../pages/Services";
import WebDesign from "../pages/WebDesign";
import CloudHosting from "../pages/CloudHosting";
import WebAppDev from "../pages/WebAppDev";
import CorporateIdentity from "../pages/CorporateIdentity";
import SearchEngineOptimizations from "../pages/SearchEngineOptimization";
import Consultancy from "../pages/Consultancy";
import CarRentalSystem from "../pages/CarRentalSystem";
import FleetManagementSystem from "../pages/FleetManagementSystem";

type RoutesType = {
  path: string;
  element: any;
  parent?: any;
};

export const routes: RoutesType[] = [
  // {
  //   path: ERROR_PATH,
  //   element: <Error />,
  // },
  {
    path: HOME_PATH,
    element: <Home />,
  },
  {
    path: ABOUT_PATH,
    element: <AboutUs />,
  },
  {
    path: CONTACT_PATH,
    element: <ContactUs />,
  },
  {
    path: SERVICES_PATH,
    element: <Services />,
  },
  {
    path: WEBDESIGN_PATH,
    element: <WebDesign />,
  },
  {
    path: CLOUDHOSTING_PATH,
    element: <CloudHosting />,
  },
  {
    path: WEBAPPDEV_PATH,
    element: <WebAppDev />,
  },
  {
    path: CORPORATE_PATH,
    element: <CorporateIdentity />,
  },
  {
    path: SEO_PATH,
    element: <SearchEngineOptimizations />,
  },
  {
    path: CONSULTANCY_PATH,
    element: <Consultancy />,
  },
  {
    path: CAR_RENTAL_PATH,
    element: <CarRentalSystem />,
  },
  {
    path: FLEET_MANAGMENT_PATH,
    element: <FleetManagementSystem />,
  },
];
